export const env = process.env.REACT_APP_ENVIRONMENT || ''
export const ENVS = {
  prod: 'production',
  qa: 'qa'
}
